// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Tekrarlı Ödemeler',
  subtitle: 'Tüm faturaları yönetin',
  newPayment: 'Yeni Ödeme',
  exportToExcel: 'Export',
  connectorInfo: 'Ödeme bağlayıcısı firma üzerinden kurulmaktadır.',
  addNewPayment: 'Yeni Tekrarlı Ödeme Ekle',
  editPayment: 'Tekrarlı Ödeme Düzenle',
  packageName: 'Paket Adı',
  packageType: 'Paket Tipi',
  purchasePrice: 'Alış Fiyatı',
  salePrice: 'Satış Fiyatı',
  frequency: 'Sıklık',
  startDate: 'Başlangıç Tarihi',
  nextPayment: 'Sonraki Ödeme Tarihi',
  paymentProbability: 'Ödeme İhtimali',
  probability: 'Ödeme İhtimali',
  profit: 'Kar',
  allCompanies: 'Tüm Firmalar',
  groupByCompany: 'Firmalara Göre Grupla',
  totalPurchase: 'Toplam Alış',
  totalSale: 'Toplam Satış',
  totalProfitLoss: 'Toplam Kar/Zarar',
  paymentCount: 'ödeme',
  extendPeriod: 'Süreyi Uzat',
  confirmExtend: 'Süre eklemek istiyor musunuz?',
  extendedSuccess: 'Süre başarıyla uzatıldı',
  extendError: 'Süre uzatılamadı',
  deleteConfirm: 'Bu ödemeyi silmek istiyor musunuz?',
  paymentDeleted: 'Tekrarlı ödeme başarıyla silindi',
  paymentAdded: 'Tekrarlı ödeme başarıyla eklendi',
  paymentUpdated: 'Tekrarlı ödeme başarıyla güncellendi',
  deleteError: 'Tekrarlı ödeme silinemedi',
  noPayments: 'Henüz tekrarlı ödeme yok',
  noPaymentsDesc: 'İlk tekrarlı ödemeyi ekleyerek başlayın.',
  noFilterResults: 'Filtreye uygun ödeme bulunamadı',
  noFilterResultsDesc: 'Farklı bir firma seçin veya filtreyi temizleyin.',
  selectCompany: 'Firma seçin',
  selectDomain: 'Domain seçin',
  noDomainsFound: 'Bu firmaya ait domain bulunamadı',
  selectHosting: 'Hosting Paketi Seçin',
  manualEntry: 'Manuel giriş yap',
  noHostingPrices: 'Hosting fiyatı tanımlanmamış',
  packagePlaceholder: 'Örn: Domain Paketi',
  getHostingPrice: 'Fiyat',
  getDomainPrice: 'Fiyat',
  whoisLookup: 'WHOIS',
  whoisTitle: 'WHOIS\'ten tarihleri çek',
  domainPriceTitle: 'Domain fiyatını getir',
  hostingPriceTitle: 'Hosting fiyatını getir',
  notes: 'Notlar',
  notesPlaceholder: 'Ek notlar...',
  cancel: 'İptal',
  addPayment: 'Ödeme Ekle',
  update: 'Güncelle',
  paymentProbabilityPlaceholder: '100',
  paymentProbabilityHint: '0-100 arası',
  selectDomainFirst: 'Lütfen önce bir domain seçin',
  domainInfoNotFound: 'Domain bilgisi bulunamadı',
  whoisLoading: 'WHOIS bilgileri sorgulanıyor...',
  whoisError: 'WHOIS bilgileri alınamadı',
  whoisParseError: 'WHOIS verileri parse edilemedi.',
  whoisNoDate: 'WHOIS verilerinde tarih bilgisi bulunamadı.',
  whoisSuccess: 'WHOIS bilgileri başarıyla alındı',
  domainExtensionError: 'Domain uzantısı çıkarılamadı',
  domainPriceNotFound: 'Bu uzantı için fiyat tanımlanmamış',
  domainPriceSuccess: 'Domain fiyatı başarıyla getirildi',
  domainPriceError: 'Domain fiyatı alınamadı',
  hostingPriceSuccess: 'Hosting fiyatı başarıyla getirildi',
  hostingPriceSuccessAuto: 'Hosting fiyatı otomatik olarak getirildi',
  hostingPriceNotFound: 'Fiyat tanımlanmamış.',
  hostingPriceError: 'Hosting fiyatı alınamadı',
  enterPackageName: 'Lütfen önce paket adı girin',
  exportSuccess: 'Tekrarlı ödemeler başarıyla export edildi',
  typeDomain: 'Domain',
  typeHosting: 'Hosting',
  typeSsl: 'SSL',
  typeEmail: 'E-posta',
  typeReklam: 'Reklam',
  typeDanismanlik: 'Danışmanlık',
  typeOther: 'Diğer',
  freqMonthly: 'Aylık',
  freqYearly: 'Yıllık',
  freqOneTime: 'Tek Seferlik',
  statusActive: 'Aktif',
  statusPassive: 'Pasif',
  daysLeft: 'gün kaldı',
  daysPast: 'gün geçti',
  overdue: 'Gecikmiş',
  today: 'Bugün',
  nA: 'N/A',
  editTitle: 'Düzenle',
  deleteTitle: 'Sil',
  extendTitle: 'Süreyi Uzat',
  oneMonth: 'Bir ay',
  oneYear: 'Bir yıl',
  hostingPackagesError: 'Hosting paketleri yüklenemedi',
  domainsLoadError: 'Domainler yüklenemedi',
  fetchError: 'Veriler alınamadı',
  exchangeRateError: 'Kur bilgileri alınamadı'
};
